import React from 'react'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <>
            <footer>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.3s" data-wow-duration="2s">
                            <div className="ftr_main">
                                <div className="footer_col">
                                    <div className="ftr_lgo">
                                        <Link to="/"><img src="images/ftr-logo.jpg" alt="img" /></Link>
                                    </div>
                                    <p>Lorem Ipsum is simply dummy text of the
                                        printing and type setting.</p>
                                    <ul className="contact_list">
                                        <li>
                                            <p><span> Email : </span><Link to="mailto:youremail.com">info@domain.com.com</Link></p>
                                        </li>
                                        <li>
                                            <p><span> Phone : </span><Link to="tel:123-456-7890">123 456 7890</Link></p>
                                        </li>
                                    </ul>
                                </div>
                                <div className="socialmedia-icons">
                                    <ul>
                                        <li>
                                            <Link target="_blank" to="https://www.facebook.com/"><i className="fab fa-facebook-f" /></Link>
                                        </li>
                                        <li>
                                            <Link target="_blank" to="https://twitter.com/"><i className="fa-brands fa-x-twitter" /></Link>
                                        </li>
                                        <li>
                                            <Link target="_blank" to="https://pk.linkedin.com/"><i className="fab fa-linkedin-in" /></Link>
                                        </li>
                                        <li>
                                            <Link target="_blank" to="https://www.instagram.com/"><i className="fab fa-instagram" /></Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.5s" data-wow-duration="2s">
                            <div className="footer_col quickl">
                                <h3>Quick Links</h3>
                                <ul className="quick_links col2">
                                    <li><Link to="/">Home</Link></li>
                                    <li><Link to="/about-us">About Us</Link></li>
                                    <li><Link to="/find-lands">Find Land</Link></li>
                                    <li><Link to="/shop">Shop</Link></li>
                                    <li><Link to="/contact-us">Contact Us</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.6s" data-wow-duration="2s">
                            <div className="footer_col usefull">
                                <h3>Useful links</h3>
                                <ul className="quick_links">
                                    <li><Link to="">Privacy Policy</Link></li>
                                    <li><Link to="">Terms of Service</Link></li>
                                    <li><Link to="">Return Policy</Link></li>
                                    <li><Link to="">FDA Disclaimer</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 wow fadeInUp" data-wow-delay="0.8s" data-wow-duration="2s">
                            <div className="footer_col">
                                <h3>Newsletters</h3>
                                <p>Sign Up For Our Newsletter To Get Up to dummy From Us</p>
                                <div className="footer_form">
                                    <form id="newsletterForm">
                                        <input type="Email" name="newsletter[newsletter_email]" placeholder="Enter Your Email" />
                                        <button type="submit" id="formsubmit">Send</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <section className="copyRight_sec ">
                <div className="container-fluid">
                    <div className="row wow fadeInUp" data-wow-delay="0.9s" data-wow-duration="2s">
                        <div className="col-lg-6 col-md-12">
                            <div>
                                <p>Spare Land © 2026 . All Rights Reserved. </p>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12">
                            <div className="footerPayment">
                                <img src="images/payment.png" className="img-fluid" alt="payment" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Footer